import React, { useState } from 'react';
import ContainerBody from '@components/ContainerBody';
import Breadcrumb from '@components/Breadcrumb';
import { List } from './components';
import { Tabs } from 'antd';
import { usePermission } from '@contexts/Auth/UsePermission';
import Page403 from '@page/Common/403/403';

const MasterDataPage = () => {
  const [active, setActive] = useState('KV');
  const { masterData } = usePermission();

  if (!masterData.view) {
    return (
      <ContainerBody>
        <Page403 />
      </ContainerBody>
    );
  }

  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath={'/dashboard'}
          routeSegments={[{ name: 'Danh mục quản lý', path: '/management-structure' }]}
        />
      </div>

      <Tabs activeKey={active} onChange={setActive}>
        <Tabs.TabPane tab="Khu vực" key="KV" />
        <Tabs.TabPane tab="Đồng hồ khối" key="DHK" />
        <Tabs.TabPane tab="Tuyến" key="TUYEN" />
      </Tabs>

      <List key={active} activeType={active} />
    </ContainerBody>
  );
};

export default MasterDataPage;
